import { Component, HostBinding, Input } from '@angular/core';
import { PwLocaleService } from '@pw-locale';

@Component({
  selector: 'pw-public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.scss'],
})
export class PublicHeaderComponent {
  @HostBinding('classList') public classList = 'mat-elevation-z12';
  @Input() internalLogoRoute: string | (string | number)[];
  @Input() externalLogoLink: string;

  constructor(public locale: PwLocaleService) {}
}
